import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const sales = new AxiosInterceptor();

export default {
  getAllSaleAnalysis(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return sales.get("/sale_analysis?" + qstr);
  },
  getCategory(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return sales.get("/sale_analysis/category?" + qstr);
  },
  getTag(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return sales.get("/sale_analysis/tag?" + qstr);
  },
  getPriceRange(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return sales.get("/sale_analysis/price_range?" + qstr);
  },
  getTopSales(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return sales.get("/sale_analysis/product?" + qstr);
  },
  getRevenue(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return sales.get("/sale_analysis/revenue_chart?" + qstr);
  }
};
